import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { placeholder, noHeaderImage } from 'src/app/models/placeholder';
import { EventService } from 'src/app/services/events/event.service';
import { UiService } from 'src/app/services/ui.service';
import { AirportListComponent } from '../../airport/airport-list/airport-list.component';
import { finalize } from 'rxjs';
import { AccountService } from 'src/app/services/user/account.service';
import { User } from 'src/app/models/user';
import { HapticServiceService } from 'src/app/services/hardware-service/haptic-service/haptic-service.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'airport-banner',
  templateUrl: './airport-banner.component.html',
  styleUrls: ['./airport-banner.component.scss'],
})
export class AirportBannerComponent implements OnInit {
  @Input() bannerInfo: any;
  @Input() userInfo: any;
  @Input() tabsInfo: string;
  @Input() tabIndex: number;
  @Input() heroContent: any;
  @Input() tabInfo: string;
  @Output() presentModal = new EventEmitter();
  @Output() airportData = new EventEmitter();
  @Output() tabStatus = new EventEmitter();
  public currentTime: string;
  public placeholder = placeholder;
  public noHeaderImage = noHeaderImage;
  public selectedLocation: any;
  public selectedAirport: any;
  public airportInfo: any;
  public pageData: any;
  public userName: string;
  public idx: number;

  constructor(
    private modalController: ModalController,
    private navController: NavController,
    private uiService: UiService,
    private eventService: EventService,
    private accountService: AccountService,
    private hapticService: HapticServiceService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.idx = this.tabIndex;
    this.userName =
      this.accountService.userInfo?.name || this.userInfo?.fullName;
    if (this.bannerInfo) {
      this.currentTime = new Date().toLocaleString('en-US', {
        timeZone: this.bannerInfo?.timeZoneRegionName,
      });
    }
  }

  async presentAirportModal() {
    this.analyticsService.trackUnified('airport_select_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'airport-banner-component',
      button: 'select-airport-button',
    });
    const modal = await this.modalController.create({
      component: AirportListComponent,
      componentProps: {
        type: 'airport_companion',
      },
      backdropDismiss: false,
    });
    modal.onDidDismiss().then(async (data) => {
      if (data.data) {
        this.initState();
        this.selectedLocation = undefined;
        this.selectedAirport = data.data.airport.airportCode;
        this.updateCampaignPageState();
      } else if (!this.selectedAirport) {
        this.navController.navigateBack(['/custom-home']);
      }
    });
    return await modal.present();
  }

  navigateTo() {
    this.analyticsService.trackUnified('chip_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'chip_clicked',
      component: 'airport-banner-component',
      landingUrl: '/membership',
    });
    this.navController.navigateBack(['/membership']);
  }

  initState() {
    this.pageData = [];
  }

  async onSegmentChange(event) {
    this.analyticsService.trackUnified('tab_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'tab_clicked',
      button:event.detail.value
    });
    this.hapticService.hapticsImpactLight();
    this.idx = event.detail.value;
    this.tabStatus.emit(this.idx);
  }

  async updateCampaignPageState() {
    this.initState();
    const loader = await this.uiService.presentGlobalLoading();
    this.eventService
      .getAirportHome(this.selectedAirport?.toUpperCase())
      .pipe(
        finalize(() => {
          loader.dismiss();
        })
      )
      .subscribe({
        next: (response) => {
          if (response?.airport?.airportData) {
            this.airportInfo = {
              ...response.airport.airportData,
              weather: response?.airport?.weather,
            };
          }
          this.airportData.emit(this.airportInfo);
          if (response?.selectedTabItems?.length > 0) {
            this.pageData = response.selectedTabItems;
          }
        },
        error: (err: any) => {
          this.analyticsService.trackResponseError(err, 'Airport Home Error');
        },
        complete: () => {},
      });
  }

  openModal() {
    this.presentModal.emit();
  }

  handleImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = placeholder;
  }
}
